$(document).ready(() => {
    (function () {
        SmoothScroll({
            animationTime: 600,
            stepSize: 40,
        });
    }());

    /* Leads bar */
    if ($('.wt-leads-fixed').length) {
        (function () {
            const controller = new ScrollMagic.Controller();

            const start = new ScrollMagic.Scene({
                triggerElement: 'main',
                triggerHook: 0.2,
            })
                .setTween('.wt-leads-fixed', 0.4, {
                    y: 0,
                })
                .addTo(controller);

            const end = new ScrollMagic.Scene({
                triggerElement: '#trigger',
                triggerHook: 0.6,
            })
                .setTween('.wt-leads-fixed', 0.4, {
                    y: '100%',
                })
                .addTo(controller);
        }());
    }

    /* Float bar */
    (function () {
        if ($('.phone-info').length) {
            $(document).on('click', '#view-phone', () => {
                $('.phone-info').toggleClass('phone-open');
            });
        }

        $(document).on('click', '#phone-close', () => {
            if ($('.phone-info').hasClass('phone-open')) {
                $('.phone-info').removeClass('phone-open');
            } else {
                return false;
            }
        });
    }());

    console.log($('.wt-leads-info.resale').length);

    // Send resale
    (function () {
        if ($('.wt-leads-info.resale').length) {
            $('.wt-leads-info.resale').each(function () {
                const email = $(this).find('.wt-leads-input');
                const button = $(this).find('.wt-button');
                const uri = button.data('url') + '?email=';

                button.on('click', function () {
                    if (email.val() != '') {
                        $(this).append('<div class="uk-margin-small-left" uk-spinner="ratio: 0.7"></div>');
                        window.location = uri + email.val();
                    } else {
                        email.addClass('invalid').attr('placeholder', 'informe seu e-mail');
                    }
                });
            });
        }
    }());
});
